/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChartWidgetViewState extends models.WidgetViewState {
    constructor() {
        super();
        this.setDiscriminator("ChartWidgetViewState");
    }

    getFixupPrototypeFunction() { return ChartWidgetViewState.fixupPrototype; }

    static newInstance(model: Partial<ChartWidgetViewState>): ChartWidgetViewState {
        let obj = Object.assign(new ChartWidgetViewState(), model);
        ChartWidgetViewState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChartWidgetViewState>): ChartWidgetViewState {
        if (!model) return null;
        return ChartWidgetViewState.newInstance(<ChartWidgetViewState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChartWidgetViewState) {
        if (!obj) return;

        models.ChartWidgetViewState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChartWidgetViewState): boolean {
        if (models.WidgetViewState.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ChartWidgetViewState.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tableLimit === undefined) {
            this.tableLimit = 0;
        }
        if (this.context) {
            models.DataContext.fixupPrototype(this.context);
        }
        if (this.groupByAccountType) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.groupByAccountType);
        }
        if (this.dimensionDetails) {
            models.BillingGroupByDetails.fixupPrototype(this.dimensionDetails);
        }
        if (this.forecast) {
            models.ForecastDuration.fixupPrototype(this.forecast);
        }
        if (this.groupByDetails) {
            for (let val of this.groupByDetails) {
                models.BillingGroupByDetails.fixupPrototype(val);
            }
        }
        if (this.drilldownContextEntries) {
            for (let val of this.drilldownContextEntries) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    context: models.DataContext;

    groupBy: Array<models.BillingGroupBySelector>;

    groupByDetails: Array<models.BillingGroupByDetails>;

    groupByAccountType: models.ServiceAccountNativeDetailsBase;

    groupByTagStatus: boolean;

    groupByWorkloadType: boolean;

    groupByResourceTagKeys: boolean;

    groupByResourceTagStatus: boolean;

    dimensionDetails: models.BillingGroupByDetails;

    dimensionResourceTagKeys: boolean;

    dimensionResourceTagStatus: boolean;

    dimensionWorkloadType: boolean;

    selectedViewBudget: string;

    primaryMetric: string;

    visibleMetrics: Array<string>;

    /**
     * When true, the data will be viewed by SBOM generation date.
     */
    viewBySbomGenerationDate: boolean;

    /**
     * Granularity to aggregate data
     */
    trendGranularity: models.TrendGranularity;

    forecast: models.ForecastDuration;

    /**
     * Chart type to display data
     */
    viewAs: models.ChartType;

    /**
     * Limit the amount of data to display
     */
    limit: models.ChartLimit;

    showVarianceColumn: boolean;

    /**
     * List of tag key/value pairs
     */
    drilldownContextEntries: Array<models.KeyValuePair>;

    isAccumulated: boolean;

    inverted: boolean;

    showFilter: boolean;

    tableLimit: number;

}
